import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=d1bcbc02&scoped=true"
import script from "./companyList.vue?vue&type=script&lang=js"
export * from "./companyList.vue?vue&type=script&lang=js"
import style0 from "./companyList.vue?vue&type=style&index=0&id=d1bcbc02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bcbc02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bcbc02')) {
      api.createRecord('d1bcbc02', component.options)
    } else {
      api.reload('d1bcbc02', component.options)
    }
    module.hot.accept("./companyList.vue?vue&type=template&id=d1bcbc02&scoped=true", function () {
      api.rerender('d1bcbc02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/advertisement/components/companyList.vue"
export default component.exports